import { environment } from './environments/environment';
import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.userPoolId,
      userPoolClientId: environment.userPoolClientId,
      loginWith: {
        oauth: {
          domain: `${environment.cognitoDomain}.auth.${environment.region}.amazoncognito.com`,
          scopes: ['email', 'openid', 'profile'],
          redirectSignIn: [environment.redirectSignIn],
          redirectSignOut: [environment.redirectSignOut],
          responseType: 'code',
        },
      },
    },
  },
});
